<br>
<div class="container-fluid px-0 calendar-responsive-page" *ngIf="appName !== 'manezylozano'">
    <div class="d-flex justify-content-start justify-content-sm-end mb-2">
        <button
            type="button"
            class="btn btn-outline-secondary btn-sm text-nowrap w-100 w-sm-auto"
            [attr.aria-pressed]="showFieldHelpButtons"
            (click)="toggleFieldHelpButtons()">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
            {{ showFieldHelpButtons ? 'Ocultar ayuda de campos' : 'Mostrar ayuda de campos' }}
        </button>
    </div>
    <div class="row g-2 align-items-end">
        <div class="col-12 col-sm-6 col-lg-2">
            <p class="mb-1">Mes:</p>
            <p-select class="w-100" id="month-dropdown" [options]="months" [formControl]="monthControl" placeholder="Mes" optionLabel="name"
            [showClear]="true" (onChange)="showSelectedDate(calendar)"></p-select>
        </div>
        <div class="col-12 col-sm-6 col-lg-2">
            <p class="mb-1">Año:</p>
            <p-select class="w-100" id="year-dropdown" [options]="years" [formControl]="yearControl" placeholder="Año" optionLabel="name"
            [showClear]="true" (onChange)="showSelectedDate(calendar)"></p-select>
        </div>
        <div class="col-12 col-lg-4">
            <p class="mb-1">{{fincaName}}:</p>
            <p-select class="w-100" [options]="fincas.filtered" [formControl]="fincaControl" placeholder="Seleccionar"
                optionLabel="label" optionValue="value" [filter]="true" [showClear]="true"
                (onChange)="filterTratamientosControl()">
            </p-select>
        </div>
        <div class="col-12 col-lg-4">
            <div class="d-grid d-sm-flex flex-sm-wrap justify-content-sm-end gap-2">
                <button type="button" class="btn btn-success btn-sm text-nowrap"  (click)="crearControl()">
                    Añadir Control
                </button>
                <button type="button" class="btn btn-primary btn-sm text-nowrap"
                    (click)="showDescargarCsv = true" [disabled]="!fincas.selected">
                    <i class="fa fa-download"></i>
                    Descargar CSV
                </button>
                <button type="button" class="btn btn-primary btn-sm text-nowrap" (click)="showImprimir()"
                    [disabled]="!fincas.selected || !selectedDate || !selectedYear">
                    <i class="fa fa-print"></i>
                    Imprimir
                </button>
            </div>
        </div>
    </div>
</div>

<div >
    <!-- <app-spinner *ngIf="loadingTelemetry"></app-spinner> -->
    <div *ngIf="loadingTelemetry">

        <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="6" animationDuration="1.5s">
        </p-progressSpinner>
    </div>
</div>
<div class="row g-3 pb-3" *ngIf="appName==='manezylozano'">
    <div class="col-12 col-md-6 col-lg-4">

        <p-select [options]="maquinarias" [formControl]="selectedMaquinariaControl" placeholder="Maquinaria"
            optionLabel="name" (onChange)="filterMaquinaria()" [filter]="true"></p-select>
    </div>
</div>

<div class="container-fluid px-0 overflow-auto" id="control-calendar">
    <full-calendar class="fc-responsive-calendar d-block w-100" id="calendar" #calendar [events]="arrayEvents" [options]="options">
    </full-calendar>
</div>

<p-dialog header="Descargar CSV" [(visible)]="showDescargarCsv" (onShow)="scrollToTop()">
    <div class="container" style="height: 360px; width: 380px; overflow: auto">
        <p>Descargar CSV de <b>{{fincas.selected?.nombre}}</b></p>

        <div>
            <p class="mt-1 mb-0">Mes y año</p>
            <div class="d-flex justify-content-left">
                <p-datePicker [formControl]="dateControl" view="month" dateFormat="MM, yy" [yearNavigator]="true"
                    yearRange="2020:2029">
                </p-datePicker>
            </div>
        </div>
    </div>
    <div class="container" style="text-align:center; max-width:480px; width: auto; overflow: auto">
        <button class="btn btn-secondary" style="margin: 10px;" (click)="showDescargarCsv = false;">Cancelar</button>
        <button class="btn btn-primary" style="margin: 10px;" (click)="downloadCsv();">
            <i class="fa fa-download"></i>
            Descargar CSV
        </button>
    </div>
</p-dialog>

<p-dialog header="Imprimir Control" [(visible)]="showImprimirControl" (onShow)="scrollToTop()">
    <div style="margin-left: 20px; margin-right: 20px; width: 80vw !important; background-color: white;">
        <div id="html2canvasDiv" class="p-4">
            <h2 class="text-center"> CONTROL DE TRATAMIENTOS PERIÓDICOS {{currentMonthAndYear}} </h2>
            <p class="my-0 text-center font-weight-bold" style="text-decoration: underline;">
                CONTROL DE TRATAMIENTOS PERIÓDICOS {{currentMonthAndYear}}
            </p>

            <table id="table-imprimir-control" class="table-hover w-100 mx-auto" style="max-width: 900px;">
                <tbody>
                    <tr>
                        <td colspan="8" class="text-center font-weight-bold p-0" style="font-size: .8rem">
                            {{fincas.selected?.nombre}}
                        </td>
                    </tr>
                    <div *ngFor="let week of (currentWeekArray || []); let i = index" [attr.data-index]="i">
                        <ng-container>
                            <tr class="text-center bg-gray">
                                <td rowspan="2" style="width: 2%; background-color: white">S. {{week}}</td>
                                <td style="width: 14%;" *ngFor="let day of currentDayMatrix[i]">
                                    {{day}}
                                </td>
                            </tr>
                            <tr style="height: 4rem;">
                                <td *ngFor="let day of currentDayMatrix[i]" [style.backgroundColor]="day > 0 && tratamientosParaImprimir[day - 1] ? 
                                            tratamientosParaImprimir[day - 1]?.color : ''">

                                    <div *ngIf="day > 0 && tratamientosParaImprimir[day - 1]" class="text-center"
                                        style="font-size: .65rem;">
                                        <div *ngIf="tratamientosParaImprimir[day - 1]?.plagas">
                                            {{tratamientosParaImprimir[day - 1]?.plagas}}
                                        </div>
                                        <div *ngIf="tratamientosParaImprimir[day - 1]?.title">
                                            {{tratamientosParaImprimir[day - 1]?.title}}
                                        </div>
                                        <div *ngIf="tratamientosParaImprimir[day - 1]?.producto1">
                                            {{tratamientosParaImprimir[day - 1]?.producto1}}
                                            {{tratamientosParaImprimir[day - 1]?.dosis1}} /
                                            {{tratamientosParaImprimir[day - 1]?.riqueza1}}
                                            <br />
                                        </div>
                                        <div *ngIf="tratamientosParaImprimir[day - 1]?.producto2">
                                            {{tratamientosParaImprimir[day - 1]?.producto2}}
                                            {{tratamientosParaImprimir[day - 1]?.dosis2}} /
                                            {{tratamientosParaImprimir[day - 1]?.riqueza2}}
                                            <br />
                                        </div>
                                        <div *ngIf="tratamientosParaImprimir[day - 1]?.producto3">
                                            {{tratamientosParaImprimir[day - 1]?.producto3}}
                                            {{tratamientosParaImprimir[day - 1]?.dosis3}} /
                                            {{tratamientosParaImprimir[day - 1]?.riqueza3}}
                                            <br />
                                        </div>
                                        <div *ngIf="tratamientosParaImprimir[day - 1]?.observaciones">
                                            {{tratamientosParaImprimir[day - 1]?.observaciones}}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </div>
                </tbody>
            </table>
        </div>

        <div class="container mt-3" style="text-align: center; max-width: 480px; width: auto; overflow: auto">
            <button class="btn btn-secondary mx-2" (click)="showImprimirControl = false;">Cancelar</button>
            <button class="btn btn-primary mx-2" (click)="imprimirControl();">
                <i class="fa fa-print"></i>
                Imprimir
            </button>
        </div>
    </div>

</p-dialog>

<a href="#" id="csvLink" style="visibility: hidden; position: fixed;"></a>
<a href="#" id="downloadControl" style="visibility: hidden; position: fixed;"></a>

<div *ngIf="appName==='manezylozano'">
    <app-dialog-tratamiento-manez #dialogTratamientos></app-dialog-tratamiento-manez>

</div>